import {Component, input} from '@angular/core';
import {iconResolver, IconType} from '../../icons';

@Component({
  selector: 'icon',
  standalone: true,
  imports: [],
  template: `{{ type() }}`,
  styles: [`
    :host {
      font-size: inherit;
      line-height: inherit;
    }
  `],
  host: {
    class: 'material-symbols-outlined'
  }
})
export class IconComponent {
  readonly type = input.required<string, IconType>({ transform: iconResolver })
}
